import { useMemo } from "react";

// tslint:disable-next-line:no-null-keyword
export function isNotNullOrUndefined<T>(input: null | undefined | T): input is T {
    // tslint:disable-next-line:no-null-keyword
    return (input != null) && (input !== undefined);
}

export function useNotNullArrayItems<T>(array: readonly (T | null)[] | null): T[] | null;
export function useNotNullArrayItems<T>(array: readonly (T | null)[] | undefined): T[] | undefined;
export function useNotNullArrayItems<T>(array: readonly (T | null)[]): T[] {
    return useMemo(() => {
        if (!array) {
            return array as T[];
        }
        return array.filter(isNotNullOrUndefined);
    }, [array]);
}